import React, { ReactNode } from 'react';

// Типы статусов для путевых листов и проверок
export type WaybillStatus = 'completed' | 'rejected' | 'processing' | 'finished';
export type CheckStatus = 'completed' | 'rejected' | 'canceled' | 'waiting' | 'inprogress';

export const statusMap = {
  completed: 'Прошел(а) мед осмотр',
  waiting: 'Ожидает медосмотра',
  inProgress: 'В процессе',
  rejected: 'Не прошел(а) мед осмотр',
};

export interface IProfile {
  id: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  role: string;
  avatar: string | null;
  isActive: boolean;
  autoparkIDs: string[] | null;
  IsInternal: boolean;
  registeredAt: string;
  loginDate: string;
}

export interface IUserBase {
  id: string;
  email: string;
  avatar: string;
  username: string;
  address: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  isActive: boolean;
  password: string;
  phone: string;
  registeredAt: string;
  role: Role;
  driverID: string;
  // null — пользователь ни разу не входил
  loginDate: string | null;
}

export interface ItechnikUser extends IUserBase {
  techlists: ITechList[];
  autoparkEmployee?: boolean;
  autoparkIDs?: string[] | null;
}

export interface ITechTOLists {
  techlists: ITechList[];
  driver: IDriverUser;
}

export interface IcarPhotos {
  frontPhoto: string;
  backPhoto: string;
  leftPhoto: string;
  rightPhoto: string;
  trunkPhoto: string;
  carID: string;
}

export interface ICarImage {
  carID: string;
  createdAt: string;
  id: string;
  photoType: string;
  photoUrl: string;
}

export interface ITechnikBase extends Omit<IUserBase, 'avatar' | 'loginDate' | 'driverID'> {
  avatar: string | null;
  loginDate: string | null;
  autoparkIDs: string[] | null;
}

export interface ICar {
  id: string;
  number: string;
  mark: string;
  model: string;
  taxiLicense: string;
  issueDate: string;
  carImages: ICarImage[];
  autonegotiation: boolean;
  autonegotiationTechnik: ITechnikBase;
  autonegotiationTechnikID?: string | null;
  autoparkID: string;
  createdAt: string;
  diagnosticCardNumber: number;
  diagnosticCardPhoto: string | null;
  diagnosticCardVerified: boolean;
  driverID: string;
  updatedAt: string;
  validityPeriodOfDC: string;
  carType?: string;
}

export interface ITechListData {
  id: string;
  body: boolean;
  carID: string;
  carImages: ICarImage[];
  chassis: boolean;
  checkStatus: 'completed' | 'rejected' | 'waiting';
  checkTime: string;
  engine: boolean;
  fullName: string;
  num: number;
  number: string;
  mark: string;
  model: string;
  odometerReading: number | string;
  optic: boolean;
  technicID: string;

  frontPhoto?: string;
  backPhoto?: string;
  leftPhoto?: string;
  rightPhoto?: string;
  trunkPhoto?: string;
}

export interface ITechList {
  id: string;
  date: string;
  num: number;
  checkTime: string;
  mark: string;
  model: string;
  engine: boolean;
  optic: boolean;
  body: boolean;
  chassis: boolean;
  odometerReading: number | string;
  checkStatus: 'completed' | 'rejected' | 'waiting' | boolean;
  carID: string;
}

export type ITechTOlist = ITechList & IDriverUser;

export interface IMedlistDriver {
  id: string;
  snils: number;
  birthDay: string;
  driverID: string;
  profile: IUserBase;
  sex: 'male' | 'female';
  licenseNumber: string;
  licenseSer: string;
  driverLicenseIssue: string;
  driverLicenseEnd: string;
}

export interface IMedList {
  id: string;
  checkTime: string;
  num: number;
  status: CheckStatus;
  bodyTemperature: number;
  bloodPressure: string;
  heartRate: number;
  bloodAlcohol: number;
  symptomsPresent: boolean;
  driverID: string;
  medicID: string;
  autopark?: IAutopark;
}

export interface IMedData {
  bloodAlcohol: number;
  bloodPressure: string;
  bodyTemperature: number;
  checkTime: string;
  driverID: string;
  heartRate: number;
  id: string;
  medicID: string;
  num: number;
  status: 'completed' | 'rejected' | 'waiting';
  symptomsPresent: boolean;
  selfie: string;
  avatar: string;
  reasonForRefusal: string | null;
  saturation: number | null;
}

export interface IRoadList {
  medlist: any;
  carID: string;
  num: number;
  techlist: any;
  id: number;
  date: string;
  status: 'completed' | 'rejected' | 'waiting';
  gosNumber: string;
  time: string;
  mark: string;
  model: string;
  odometr: number | string;
  medStatus: boolean;
  TO: string;
  TOstatus: boolean;
  url?: string;
}

export interface IDriverUser extends IUserBase {
  profile: any;
  id: string;
  snils: number;
  birthDate: string;
  driverID: string;
  sex: 'male' | 'female';
  licenseNumber: string;
  licenseSer: string;
  licenseIssueDate: string;
  licenseExpireDate: string;
  cars: ICar[];
  roadlists: IRoadList[];
  medlists: IMedList[];
  techlists: ITechList[];
}

export interface IWaybill {
  id: number;
  requestDateTime: Date;
  car: {
    licensePlate: string;
    mark: string;
    model: string;
  };
  status: boolean;
  pdfFileUrl?: string;
}

export interface IMedicCheck {
  id: number;
  selfiePhoto: string;
  healthComplaints: boolean;
  bodyTemperature: number;
  breathalyzerResult: number;
  bloodPressure: string;
  pulse: number;
  medicConclusion: boolean;
}

export interface IMechanicCheck {
  id: number;
  engine: boolean;
  optics: boolean;
  bodyAndInterior: boolean;
  chassis: boolean;
}

export interface IMedicApplicationCard {
  id: number;
  requestDateTime: Date;
  fullName: string;
  birthday: Date;
  avat: string;
  applicationSelfiePhoto: string;
  bodyTemperature: number;
  breathalyzerResult: number;
  bloodPressure: string;
  pulse: number;
  healthComplaints: boolean;
  medicConclusion: boolean;
}

export interface ItechnikianApplicationCard {
  id: number;
  requestDateTime: Date;
  data: string;
  time: string;
  fullName: string;
  carPhotos: {
    front: string;
    rightSide: string;
    backWithClosedTrunk: string;
    leftSide: string;
    trunkContents: string;
  };
  mechanicCheck: {
    engine: boolean;
    optics: boolean;
    bodyAndInterior: boolean;
    chassis: boolean;
    conclusion: boolean;
  };
}

export interface ITabsData {
  id?: number;
  name?: string;
  title?: string;
  component: ReactNode;
  style?: string | React.CSSProperties;
}

export type Role = 'admin' | 'medic' | 'technik' | 'driver' | 'autopark_employee';
export type Sex = 'male' | 'female';

interface HasValue<V> {
  value: V;
}

export interface DropdownItemRole extends HasValue<Role> {
  text: string;
}

export interface DropdownItemStatus extends HasValue<boolean | string> {
  text: string;
}

export interface DropdownItemSex extends HasValue<Sex> {
  text: string;
}

export interface DropdownProps<T extends HasValue<unknown>> {
  items: T[];
  onSelect: (value: T['value']) => void;
  initialValue?: T['value'];
  editable: boolean;
  style?: React.CSSProperties;
}

export type FilterQuery = 'fullName' | 'phoneNumber' | 'login';

export type IUser = IUserBase | IDriverUser;

export interface IQueryParams {
  i_id: string;
  i_name: string;
  i_type: string;
  i_value: string;
  i_label: string;
}

export interface IMedic extends IUserBase {
  medlists: IMedList[];
  autoparkEmployee?: boolean;
  autoparkIDs?: string[] | null;
}

export interface IAuthResponse {
  access_token: string;
  refresh_token: string;
  user: IServerUser;
}

export interface IServerUser {
  id: string;
  email: string;
  avatar: string;
  username: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  password: string;
  phone: string;
  registeredAt: string;
  role: string;
  driverID: string;
  loginDate: string;
}

export interface IAutopark {
  actualAddress: string;
  balance: number;
  bankName: string;
  bik: string;
  currentAccount: string;
  email: string;
  fullnameEmployee: string;
  fullnameOwner: string;
  id: string;
  inn: string;
  kpp: string;
  legalAddress: string;
  legalName: string;
  ogrn: string;
  phone: string;
  tradeName: string;
}

export interface IDriverInfo {
  id: string;
  sex: 'male' | 'female';
  licenseNumber: string;
  licenseSer: string;
  healthRestrictions: boolean;
  snils: string;
  birthDate: string;
  licenseIssueDate: string;
  licenseExpireDate: string;
}

export interface IMedicalCheck {
  checkTime: string;
  id: string;
  bodyTemperature: number;
  bloodAlcohol: number;
  bloodPressure: string;
  heartRate: number;
  num: number;
  symptomsPresent: boolean;
  status: 'completed' | 'rejected' | 'waiting' | 'completed';
  autopark: IAutopark | null;
  driverProfile: IProfile;
  driver: IDriverInfo;
  reasonForRefusal: string | null;
  saturation: number | null;
  medic: IMedic | null;
}

export interface ITechCheckResponse {
  data: ITechCheckItem[];
  page: number;
  totalPages: number;
  totalCount: number;
}

export interface ITechCheckItem {
  autopark: IAutopark;
  body: boolean;
  car: ICar;
  chassis: boolean;
  checkStatus: 'completed' | 'completed' | 'rejected' | 'waiting';
  checkTime: string;
  engine: boolean;
  id: string;
  num: number;
  odometerReading: number;
  odometerPhoto: string;
  optic: boolean;
  profile: IProfile;
  reasonForRefusal: string | null;
  technicID: string;
}

// Типы для тарифов
export interface ITariff {
  id: string;
  title: string;
  allowPrice: number;
  countOfRL: number;
  priceForOne: number;
}

export interface ITariffResponse {
  data: ITariff[];
  page: number;
  totalCount: number;
  totalPages: number;
}

export interface ITariffCreateRequest {
  title: string;
  allowPrice: number;
  countOfRL: number;
}

export interface ITariffUpdateRequest {
  allowPrice: number;
  countOfRL: number;
  title: string;
}
